(function () {
  'use strict';

  var watched = new WeakSet();

  function isVisible(element) {
    return Boolean(
      element &&
      window.getComputedStyle(element).display !== 'none' &&
      element.getBoundingClientRect().height > 0
    );
  }

  function setImportant(element, property, value) {
    if (!element) return;
    if (
      element.style.getPropertyValue(property) !== value ||
      element.style.getPropertyPriority(property) !== 'important'
    ) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function syncMobileFloaters() {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var banner = document.getElementById('shopify-pc__banner');
    var googleBadge = document.getElementById('google-merchantwidget-iframe-wrapper');
    var language = document.getElementById('arc_language_selector');

    document.body.classList.toggle('cookie-banner-visible', mobile && isVisible(banner));

    if (mobile) {
      setImportant(googleBadge, 'bottom', 'calc(60px + env(safe-area-inset-bottom))');
      setImportant(language, 'bottom', 'calc(136px + env(safe-area-inset-bottom))');
      setImportant(language, 'right', '12px');
    }
  }

  function watch(element) {
    if (!element || watched.has(element)) return;
    watched.add(element);
    new MutationObserver(syncMobileFloaters).observe(element, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
  }

  function discover() {
    watch(document.getElementById('shopify-pc__banner'));
    watch(document.getElementById('google-merchantwidget-iframe-wrapper'));
    watch(document.getElementById('arc_language_selector'));
    syncMobileFloaters();
  }

  function init() {
    new MutationObserver(discover).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    window.addEventListener('resize', syncMobileFloaters, { passive: true });
    discover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
